import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  typography: {
    fontFamily: ['"Lato"', 'sans-serif'].join(',')
   }
})

export default theme;